import axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import router from "@/router";

const URL_API_AUTH = process.env.VUE_APP_API_URL + "auth/";
const URL_API_USER = process.env.VUE_APP_API_URL + "user/";

export default {
  login(rut, password) {
    let data = {
      usuario: rut,
      clave: password,
    };
    return axios.post(URL_API_AUTH + "login", data);
  },
  userInfo(id_cliente) {
    let data = {
      id_cliente: id_cliente,
    };
    return axios.post(URL_API_USER + "info_cliente", data);
  },
  bitsCliente(id_cliente) {
    let data = {
      clien_s_id: id_cliente,
    };
    return axios.post(URL_API_USER + "bits_cliente", data);
  },
  info_campanias(id_cliente) {
    return axios.get(URL_API_USER + "info_campanias/" + id_cliente);
  },
  generarClave(data) {
    return axios.post(URL_API_AUTH + "recuperar_clave", data);
  },
  cambiarClave(rut, cl_actual, cl_nueva, accion) {
    let data = {
      id_cliente: rut,
      clave_old: cl_actual,
      clave: cl_nueva,
      accion: accion,
    };
    return axios.post(URL_API_AUTH + "cambiar_clave", data);
  },

  async setUserLogged(userLogged) {
    var expireTime = new Date(new Date().getTime() + 14.95 * 60 * 1000);
    delete userLogged.imagen_b64;
    var usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    Cookies.set("userLoggedTC", usuarioEncriptado, {
      expires: expireTime,
    });
    //store.dispatch("updateBits");
    Cookies.set("userLoggedExpiredTC", expireTime);
  },

  getUserLogged() {
    let usuarioEncriptado = Cookies.get("userLoggedTC");
    var bytes = CryptoJS.AES.decrypt(
      usuarioEncriptado,
      process.env.VUE_APP_CRYPT_KEY
    );
    var usuario = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(usuario);
  },
  cerrarSesion() {
    Cookies.remove("userLoggedExpiredTC");
    Cookies.remove("userLoggedTC");
    router.push({ name: "login" });
  },
  isAuthenticated() {
    return Cookies.get("userLoggedTC") !== undefined;
  },
  isExpireSet() {
    return Cookies.get("userLoggedExpiredTC") !== undefined;
  },

  // datosCliente(form) {
  //   let data = qs.stringify(form);
  //   //const user = { rut, password };
  //   return axios.post(URL_API + "datos_cliente", data);
  // },
};
